import { FeedbackError } from "../../feedback/feedbackRules";
import type { FeedbackReport, FeedbackReportInput } from "../../types";
import { getSupabaseClient } from "./supabase";

/** Postgres codes of the Spanish exceptions raised by the TASK-060 triggers (no profile, rate limit, guards). */
const SERVER_MESSAGE_CODES = ["P0001", "42501"];

const FALLBACK_MESSAGE = "No pudimos enviar tu comentario. Inténtalo de nuevo.";

/**
 * Inserts a feedback report. The author has no SELECT policy on
 * `feedback_reports`, so the insert must not read the row back:
 * supabase-js sends `Prefer: return=minimal` when `.select()` is not chained
 * (a `return=representation` insert would be rejected by RLS). Only the
 * client-supplied columns are sent: `created_by`, `status` and the review
 * stamps are server-set.
 */
export const insertFeedbackReport = async (
  input: FeedbackReportInput,
): Promise<{ data: FeedbackReport }> => {
  const row = {
    kind: input.kind,
    message: input.message,
    screen_path: input.screen_path,
    screen_title: input.screen_title,
    viewport: input.viewport,
    app_locale: input.app_locale ?? null,
    user_agent: input.user_agent ?? null,
  };
  const { error } = await getSupabaseClient()
    .from("feedback_reports")
    .insert(row);
  if (error) {
    const isServerMessage = SERVER_MESSAGE_CODES.includes(error.code);
    throw new FeedbackError(isServerMessage ? error.message : FALLBACK_MESSAGE);
  }
  // Nothing is read back; react-admin only needs a record with an id.
  return { data: { ...row, id: 0 } as FeedbackReport };
};
